// @flow

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import {
  log,
  formatPhoneNumberForFrontend,
  formatPhoneNumberForBackend
} from '../../utils/jsUtils';
import StyledPhoneInput from '../SharedComponents/StyledPhoneInput';

import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import Card from '@mui/material/Card';
import InputLabel from '@mui/material/InputLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { createClasses } from '../../utils/stylesUtils';
import SPBackend from '../../services/SPBackend';
import {ROLE_NAMES, getUserRole, getRolePower} from '../../models/User';
import editStaffDialogStyles from './Styles/EditStaffDialog.Style';
import { selectUser, selectUserEmail, selectUserRole } from '../../reduxStore/modules/user/selectors';
import type { User } from '../../services/SPBackend';

type Props = {
  setOpen: Function,
  open: boolean,
  triggerAction: Function,
  staff: User
};


// eslint-disable-next-line react/no-multi-comp
const EditStaff = (props: Props) => {
  const { setOpen, open, triggerAction, staff } = props;

  // Redux hooks
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const email = useSelector(selectUserEmail);
  const userRole = useSelector(selectUserRole);
  
  // MUI 5 styling
  const theme = useTheme();
  const classes = createClasses(editStaffDialogStyles, theme);
  

  // const [loggedUser, setloggedUser] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const [changedStaff, setChangedStaff] = useState({
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    IsAdmin: false,
    IsManager: false,
    IsOwner: false
  });

  const [openDrop, setOpenDrop] = useState(false);

  // const getUserInAccount = () => {
  //   if (user !== null) {
  //     SPBackend.getCurrentUser(user)
  //     .then((response) => {
  //       const { data } = response;
  //       setloggedUser(data);
  //     })
  //     .catch((error) => {
  //       log('[TenantsHome.fetchFeed.getFeed] error: ', error);
  //     });
  //   }
  // };

  useEffect(() => {
    if (user !== null && staff !== null) {
      setChangedStaff((prevStaff) => {
        return {
          ...prevStaff,
          FirstName: staff ? staff.FirstName : '',
          LastName: staff ? staff.LastName : '',
          Email: staff ? staff.Email : '',
          Phone: staff ? formatPhoneNumberForFrontend(staff.Phone) : '',
          IsAdmin: staff ? staff.IsAdmin : false,
          IsManager: staff ? staff.IsManager : false,
          IsOwner: staff ? staff.IsOwner : false
        };
      });
      // getUserInAccount();
    }
  }, [staff]);

  // log('userRole: ', userRole);
  // log('staff: ', staff);
  return (
    <Dialog
      aria-labelledby='form-edit-staff'
      onClose={() => setOpen(false)}
      open={open}
    >
      <form
        autoComplete='off'
        style={classes.dialogFormCtr}
        noValidate
        onSubmit={e => {
          e.preventDefault();

          setErrorMessage('');

          triggerAction({
            ...changedStaff,
            Phone: formatPhoneNumberForBackend(changedStaff.Phone) || ''
          });
          setOpen(false);
        }}
      >
        <DialogTitle id='form-dialog-title'>{'Edit Staff Profile'}</DialogTitle>
        <DialogContent sx={{ ...classes.grow, ...classes.flexContainer }}>
          <DialogContentText sx={classes.error}>{ errorMessage }</DialogContentText>
          <Box id="editStaff"> 
            <Input
                autoFocus
                sx={classes.secondInput}
                value={changedStaff.FirstName}
                fullWidth
                id='firstName'
                placeholder='First Name'
                margin='dense'
                onChange={e => {
                e.persist();
                setChangedStaff((prevStaff) => {
                    return {
                      ...prevStaff,
                      FirstName: e.target.value
                    };
                  });
                }}
                required
                type='text'
            />
            <Input
              autoFocus
              sx={classes.secondInput}
              value={changedStaff.LastName}
              fullWidth
              id='lastName'
              placeholder='Last Name'
              margin='dense'
              onChange={e => {
                e.persist();
                setChangedStaff((prevStaff) => {
                  return {
                    ...prevStaff,
                    LastName: e.target.value
                  };
                });
              }}
              required
              type='text'
            />
            <Input
              autoFocus
              sx={classes.secondInput}
              value={changedStaff.Email}
              disabled
              fullWidth
              id='email'
              placeholder='Email'
              margin='dense'
              onChange={e => {
                e.persist();
                setChangedStaff((prevStaff) => {
                  return {
                    ...prevStaff,
                    Email: e.target.value
                  };
                });
              }}
              required
              type='text'
            />
            <Box sx={{ marginTop: 2 }}>
              <StyledPhoneInput
                defaultCountry='US'
                onChange={e =>
                  setChangedStaff({
                    ...changedStaff,
                    Phone: e
                  })
                }
                placeholder="Enter phone number"
                value={changedStaff ? changedStaff.Phone : ''}
              />
            </Box>
            <br/>  
            {
              staff
              && userRole === ROLE_NAMES.OWNER
              ? <List disablePadding>
                <InputLabel htmlFor="demo-controlled-open-select" >
                    {'Role'}
                </InputLabel>
                <Card sx={classes.card}>
                  <ListItem
                    button
                    key={'Role'}
                    onClick={() => setOpenDrop(!openDrop)}
                  >
                    <ListItemText
                      primary={getUserRole(changedStaff)}
                    />
                    {openDrop ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                </Card>
                <Collapse
                  sx={classes.userProfileSubMenuCollapse}
                  in={openDrop}
                  timeout="auto"
                  unmountOnExit
                >
                <Card sx={classes.card}>
                {
                  staff
                  && !staff.IsOwner
                  ? <ListItem
                      button
                      key={'Owner'}
                    >
                      <ListItemText
                        sx={classes.itemTextCtr}
                        onClick={() => {
                          setChangedStaff((prev) => {
                            return {
                              ...prev,
                              IsOwner: true,
                              IsAdmin: false,
                              IsManager: false
                            };
                          });
                          setOpenDrop(false);
                        }}
                        primary={'Owner'}
                      />
                    </ListItem>
                  : null
                }
                  <ListItem
                    button
                    key={'Staff'}
                    onClick={() => {
                      setChangedStaff((prev) => {
                        return {
                          ...prev,
                          IsOwner: false,
                          IsAdmin: false,
                          IsManager: false
                        };
                      });
                      setOpenDrop(false);
                    }}
                  >
                    <ListItemText
                      sx={classes.itemTextCtr}
                      primary={'Staff'}
                    />
                  </ListItem>
                </Card>
                </Collapse>
              </List>
              :null
            }
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color='primary'
            onClick={() => setOpen(false)}
          >
            {'Cancel'}
          </Button>
          {
            staff && staff.Invite && staff.Invite.Status !== 'accepted' && moment().diff(staff.Invite.CreatedDt, 'days', true) > 1
            ? <Button
                color='primary'
                type='submit'
                variant='contained'
              >
                {'Save & Resend Invite'}
              </Button>
            : <Button
              color='primary'
              type='submit'
              variant='contained'
              >
              {'Save'}
            </Button>
          }
        </DialogActions>
       </form>
    </Dialog>
  );
};

export default EditStaff;
